import { useMemo } from 'react';
import type { PortPickerEntry } from '../../../utils/electronicsDashboardUtils';
import ChoosePort from './ChoosePort';

/** Header toolbar for multi-instance port stream widgets (motors, mechanisms, sensors). */
export function useChoosePortsToolbar({
  show,
  isHistoricMode,
  entries,
  selectedPorts,
  onSelectedPortsChange,
  disabled,
  selectedPortsKey,
  chooseButtonI18nKey,
  chooseButtonDefault,
  chooseAllI18nKey,
  chooseAllDefault,
  variant = 'toolbar',
}: {
  show: boolean;
  isHistoricMode: boolean;
  entries: readonly PortPickerEntry[];
  selectedPorts: readonly number[];
  onSelectedPortsChange: (ports: number[]) => void;
  disabled?: boolean;
  /** Stable dep when `selectedPorts` is a new array reference with the same values. */
  selectedPortsKey: string;
  chooseButtonI18nKey: string;
  chooseButtonDefault: string;
  chooseAllI18nKey: string;
  chooseAllDefault: string;
  variant?: 'toolbar' | 'drawer';
}) {
  return useMemo(() => {
    if (isHistoricMode || !show) return null;
    return (
      <ChoosePort
        entries={[...entries]}
        selectedPorts={[...selectedPorts]}
        onSelectedPortsChange={onSelectedPortsChange}
        disabled={disabled}
        variant={variant}
        chooseButtonI18nKey={chooseButtonI18nKey}
        chooseButtonDefault={chooseButtonDefault}
        chooseAllI18nKey={chooseAllI18nKey}
        chooseAllDefault={chooseAllDefault}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selectedPortsKey avoids array identity churn on selectedPorts
  }, [
    chooseAllDefault,
    chooseAllI18nKey,
    chooseButtonDefault,
    chooseButtonI18nKey,
    disabled,
    entries,
    isHistoricMode,
    onSelectedPortsChange,
    selectedPorts,
    selectedPortsKey,
    show,
    variant,
  ]);
}
